// @ts-nocheck

import { downloadRequestWithToken, fetchRequest } from './index';
/**
 * Получение отчета
 */
export const fetchReportWeekendOrders = async params => {
  const report = await fetchRequest.get('/report/weekendOrder', {
    ...params
  });
  return report;
};

/**
 * Печать отчета
 */
export const printReportWeekendOrders = async params => {
  const isPrinted = await downloadRequestWithToken('/report/weekendOrder/print', {
    ...params
  });
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};
export default {
  fetchReportWeekendOrders,
  printReportWeekendOrders
};
